module.exports = __webpack_public_path__ + "img/W-G13.61101aed.jpg";